/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([ './Button', 'underscore' ], function(Button, _) {

	var ToggleButton = null;

	/**
	 * Represents a toggle button that can be added to an app bar or other container like ToggleButtonBar
	 */
	ToggleButton = Button.extend({
		events: { 'click': 'toggleHandler' },
		baseClass: 'appbar',
		checked: false,
		icon: null,
		_sInactiveIcon: null,
		_sHighlightedIcon: null,

		/**
		 * Creates a new item
		 *
		 * @param spec -
		 *            The toggle button spec
		 * @param root -
		 *            A reference to the root menu item, where items go if the app bar is collapsed horizontally
		 */
		init: function(spec) {
			_.extend(this, spec);
			ToggleButton.inherited('init', this, arguments);
			this._updateIcon();
		},

		toggleHandler: function() {
			if (this.$('button').prop('disabled')) {
				return;
			}
			if (this.containerCallbacks && this.containerCallbacks.click) {
				this.containerCallbacks.click(this.name);
			}

			if (this.checked) {
				this.unselect();
			} else {
				this.select();
			}
		},

		unselect: function() {
			this.updateUI(false);
			if (typeof this.offAction === 'function') {
				this.offAction();
			}
		},

		select: function() {
			this.updateUI(true);
			if (typeof this.action === 'function') {
				this.action();
			}
		},

		_updateIcon: function() {
			this.$el.toggleClass(`${this.baseClass}ItemToggled`, this.checked);
		},

		updateUI: function(bChecked) {
			this.checked = bChecked;
			this._updateIcon();
			this.render();
		}

	});

	return ToggleButton;
});
